import { format } from 'date-fns'

import { useWorkstationStore } from '@/modules/Workstation/store'
import { useDateStore } from '@/components/DateInput'
import { DisruptionsTable } from './components/DisruptionsTable'
import styles from './Disruptions.module.scss'

export const ControllerDisruptions = () => {
    const { workstation } = useWorkstationStore()
    const { date } = useDateStore()

    const title = workstation ? workstation.workstationNumber : 'Workstation'

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <div className={styles.details}>
                    <h1 className={styles.title}>{title} disruptions</h1>
                    <p className={styles.date}>{format(date, 'cccc d MMMM')}</p>
                </div>
            </header>
            <div className={styles.container}>
                <DisruptionsTable />
            </div>
        </section>
    )
}
